var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"pay-range-subscription-bar",class:`pay-range-subscription-bar--${_setup.normalizedState}`,attrs:{"role":"img","aria-label":_setup.accessibleLabel}},[_c('span',{staticClass:"pay-range-subscription-bar__label"},[_vm._v(_vm._s(_setup.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }